import cn from 'bem-cn';

import { Skeleton, Stack } from '../../../UI';

import './PromptCard.mobile.scss';

const b = cn('prompt-card-new-mobile');

export const PromptCardNewMobileSkeleton = () => {
    return (
        <Stack className={b({ skeleton: true })}>
            <Stack className={b('header')} direction="row">
                <Skeleton variant="circular" className={b('header', 'avatar')} />
                <Skeleton variant="rounded" className={b('header', 'like')} width={70} height={24} />
            </Stack>
            <Stack className={b('main')}>
                <Skeleton variant="rectangular" className={b('main', 'media')} />
                <Stack spacing={4} className={b('main', 'text')} style={{ display: 'flex', overflow: 'unset' }}>
                    <Skeleton width="80%" />
                    <Skeleton />
                    <Skeleton width="70%" />
                </Stack>
            </Stack>
            <Stack className={b('footer')}>
                <Skeleton
                    variant="rounded"
                    height={44}
                    className={b('footer', 'button')}
                    style={{ borderRadius: '999px' }}
                />
            </Stack>
        </Stack>
    );
};
